<template>
  <label :class="[classList, $attrs.class]" :style="$attrs.style">
    <input
      v-bind="inputAttrs"
      :type="type"
      :checked="state"
      class="c-switch-input form-check-input"
      @change="onChange"
    >
    <span :data-checked="labelOn" :data-unchecked="labelOff" class="c-switch-slider"></span>
  </label>
</template>

<script>
import { innerAttrs } from './utils'

export default {
  name: 'CSwitch',
  inheritAttrs: false,
  props: {
    color: String,
    variant: String,
    size: String,
    shape: String,
    checked: Boolean,
    labelOn: String,
    labelOff: String,
    type: { type: String, default: 'checkbox' }
  },
  emits: ['update:checked'],
  data () {
    return { state: undefined }
  },
  watch: {
    checked: {
      immediate: true,
      handler (val) { this.state = val }
    }
  },
  computed: {
    // Vue 2 version bound $attrs (no listeners) to the input
    inputAttrs () {
      return innerAttrs(this.$attrs, { listeners: false })
    },
    classList () {
      const variant = this.variant ? `-${this.variant}` : ''
      return [
        'c-switch form-check-label',
        {
          [`c-switch-${this.size}`]: this.size,
          [`c-switch-${this.shape}`]: this.shape,
          [`c-switch${variant}-${this.color}`]: this.color,
          'c-switch-label': this.labelOn || this.labelOff
        }
      ]
    }
  },
  methods: {
    onChange (e) {
      this.state = e.target.checked
      this.$emit('update:checked', e.target.checked, e)
    }
  }
}
</script>
